import React from 'react';
import { NavLink } from 'react-router-dom';
import { css } from '@emotion/css';

const voicifyLogo = require('../../../shared/content/images/voicify-logo-horizontal.png');

export const LAUNCH_CONTRACT_TYPES = [
    { label: 'Healthcare', value: 'Medical' },
    { label: 'AI Ordering', value: 'AI Ordering' },
    { label: 'AI Answering', value: 'AI Answering' },
    { label: 'Drive-Thru', value: 'Drive Thru' }
];

interface LaunchDashboardSubnavProps {
    selectedContractType: string;
    selectedYear: number;
    selectedMonth: number;
    yearOptions: number[];
    onContractTypeChange: (value: string) => void;
    onYearChange: (value: number) => void;
    onMonthChange: (value: number) => void;
    allowAllMonths?: boolean;
}

export const CrossOrganizationSubnav: React.FC<{ children?: React.ReactNode }> = ({ children }) => (
    <section className={subnav}>
        <nav aria-label="Cross-organization dashboard navigation">
            <NavLink exact to="/v/assistant-launches" activeClassName={activeLink}>Launch overview</NavLink>
            <NavLink exact to="/v/launch-calendar" activeClassName={activeLink}>Launch calendar</NavLink>
            <NavLink exact to="/v/organization-overview" activeClassName={activeLink}>Organization overview</NavLink>
            <NavLink exact to="/v/account-health" activeClassName={activeLink}>Account health</NavLink>
        </nav>
        {children && <div className={filters}>{children}</div>}
    </section>
);

export const LaunchDashboardHeader: React.FC<{ title: string, description: string }> = ({ title, description }) => (
    <header className={launchHeader}>
        <img src={voicifyLogo} alt="Voicify" />
        <div>
            <h1>{title}</h1>
            <p>{description}</p>
        </div>
    </header>
);

const LaunchDashboardSubnav: React.FC<LaunchDashboardSubnavProps> = (props) => (
    <CrossOrganizationSubnav>
            <label>
                Contract type
                <select aria-label="Contract type" value={props.selectedContractType} onChange={event => props.onContractTypeChange(event.target.value)}>
                    <option value="all">All contract types</option>
                    {LAUNCH_CONTRACT_TYPES.map(type => <option value={type.value} key={type.value}>{type.label}</option>)}
                </select>
            </label>
            <label>
                Launch year
                <select aria-label="Launch year" value={props.selectedYear} onChange={event => props.onYearChange(Number(event.target.value))}>
                    {props.yearOptions.map(year => <option value={year} key={year}>{year}</option>)}
                </select>
            </label>
            <label>
                Month
                <select aria-label="Launch month" value={props.selectedMonth} onChange={event => props.onMonthChange(Number(event.target.value))}>
                    {props.allowAllMonths && <option value={-1}>All months</option>}
                    {Array.from({ length: 12 }, (_, month) => <option value={month} key={month}>{new Date(2020, month, 1).toLocaleDateString(undefined, { month: 'long' })}</option>)}
                </select>
            </label>
    </CrossOrganizationSubnav>
);

const subnav = css`display: flex; align-items: flex-end; justify-content: space-between; gap: 20px; margin-bottom: 24px; padding: 14px 18px; border-radius: 10px; background: white; box-shadow: 0 1px 3px rgba(25, 50, 70, .12); nav { display: flex; gap: 6px; align-items: center; } nav a { padding: 9px 12px; border-radius: 6px; color: #5e6d79; font-size: 13px; font-weight: bold; text-decoration: none; } @media (max-width: 900px) { align-items: stretch; flex-direction: column; }`;
const launchHeader = css`display: flex; align-items: center; gap: 24px; margin-bottom: 24px; img { display: block; width: 164px; height: auto; flex: 0 0 auto; } h1 { margin: 0; font-size: 28px; } p { margin: 6px 0 0; color: #5e6d79; } @media (max-width: 700px) { align-items: flex-start; flex-direction: column; gap: 16px; img { width: 145px; } }`;
const activeLink = css`background: #e1f2fa; color: #075579 !important;`;
const filters = css`display: flex; gap: 12px; label { display: grid; gap: 5px; color: #5e6d79; font-size: 11px; font-weight: bold; } select, input { box-sizing: border-box; min-width: 145px; padding: 9px; border: 1px solid #c6d2db; border-radius: 6px; background: white; color: #263747; font: inherit; } @media (max-width: 700px) { flex-direction: column; label, select, input { width: 100%; } }`;

export default LaunchDashboardSubnav;
